import { ApiService } from 'src/app/shared/services';
import { SharedPortalViewService } from './../shared-portal-view.service';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Observable, Subscription, last, lastValueFrom } from 'rxjs';
import { PageItem } from 'src/app/models/portal';
import {
  SetWebsiteBrandingRequestBody,
  SetWebsiteIdentityRequestBody,
  WebsiteIdentity,
  WebsiteModel,
  ColorPalette,
} from '../../portal.model';
import { Store } from '@ngrx/store';
import {
  selectWebsite,
  isWebsiteLoaded,
  selectWebsiteIdentity,
} from 'src/app/shared/store/_features/website/website.selector';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {
  FormSectionModel,
  FromSectionContext,
} from 'src/app/models/multiple-sections-form';
import { ToastrService } from 'ngx-toastr';
import { InOutAnimation } from 'src/app/shared/animations/animations';
import { COLOR_PALETTES } from 'src/app/shared/layout/owner-dashboard/account-setup-wizard/steps/hub-branding-step/color-palette-selector/color-palette-selector.component';

@Component({
  selector: 'app-portal-design',
  templateUrl: './portal-design.component.html',
  styleUrls: ['./portal-design.component.css'],
  animations: [InOutAnimation],
})
export class PortalDesignComponent implements OnInit, OnDestroy, AfterViewInit {
  loaded: boolean = false;
  processing: boolean = false;
  portalIdentityConfigurationForm = new FormGroup({
    favIcon: new FormControl([], {}),
    favIcon_id: new FormControl([], {
      updateOn: 'change',
    }),
    logo: new FormControl([], {}),
    logo_id: new FormControl([], {
      updateOn: 'change',
    }),
    color_palette: new FormControl<ColorPalette>(null, {
      updateOn: 'change',
    }),
  });

  identity: WebsiteIdentity;
  selectedPalette: ColorPalette;

  @ViewChild('EditBranding') EditBrandingTemplate!: TemplateRef<any>;
  // @ViewChild('EditMetaDetails') EditMetaDetailsTemplate!: TemplateRef<any>;

  formSections: FormSectionModel[] = [
    {
      title: 'Logo & Branding',
      template: this.EditBrandingTemplate,
      templateName: 'EditBrandingTemplate',

      context: {
        actionsSection: {
          isSaveEnable: false,
          showAlways: true,
          isStick: false,
        },
        title: 'Logo & Branding',
        description: '',
        controls: ['logo', 'logo_id', 'favIcon', 'favIcon_id', 'color_palette'],
      },
    },
  ];

  subscriptions: Subscription[] = [];

  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    private api: ApiService,
    private store: Store,
    private toastr: ToastrService
  ) {
    this.subscriptions.push(
      this.store.select(selectWebsiteIdentity).subscribe((value) => {
        this.identity = value;
        this.portalIdentityConfigurationForm.patchValue(value, {
          emitEvent: false,
        });

        if (value.color_palette) {
          this.selectedPalette = value.color_palette;
        }

        this.loaded = true;
      })
    );
  }
  ngAfterViewInit(): void {
    this.formSections.forEach((section) => {
      section.template = this[section.templateName];
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngOnInit() {
    this.trackFormChanges();
    // this.subscriptions.push(
    // this.website$.pipe(last()).subscribe(async (lastValue) => {
    //   this.loaded.pages = false;
    //   let pages$ = this.api.getWebsitePages(lastValue.id);
    //   let pages: PageItem[] = await lastValueFrom(pages$);
    //   this.sharedPortalViewService.currentWebsite.pages = pages;
    //   this.loaded.pages = true;
    // }));
  }

  onSelectPalette(palette: ColorPalette) {
    if (!palette) return;

    this.selectedPalette = palette;
    this.portalIdentityConfigurationForm.patchValue({
      color_palette: palette,
    });
  }

  resetSection(context: FromSectionContext) {
    //
    Object.keys(this.portalIdentityConfigurationForm.controls).forEach(
      (controlName) => {
        //
        if (context?.controls?.includes(controlName)) {
          this.portalIdentityConfigurationForm
            .get(controlName)
            ?.setValue(this.identity[controlName], {
              emitEvent: false,
            });
          context.actionsSection.isSaveEnable = false;
        }
      }
    );

    // Reset local palette selection
    if (this.identity.color_palette) {
      this.selectedPalette = this.identity.color_palette;
    } else {
      this.selectedPalette = null;
    }
  }

  async onSave() {
    let payload: SetWebsiteBrandingRequestBody = {
      favIcon_id: this.portalIdentityConfigurationForm.value.favIcon_id,
      logo_id: this.portalIdentityConfigurationForm.value.logo_id,
      color_palette: this.portalIdentityConfigurationForm.value.color_palette,
    };
    this.processing = true;
    await this.sharedPortalViewService.setWebsiteIdentity(payload);
    this.toastr.success('Updated Successfully');
    this.processing = false;
  }

  trackFormChanges() {
    // this.subscriptions.push(
    //   this.portalIdentityConfigurationForm.valueChanges.subscribe((value) => {
    //     this.sharedProductService.disableNavigate();
    //   })
    // );

    Object.keys(this.portalIdentityConfigurationForm.controls).forEach(
      (controlName) => {
        //
        this.subscriptions.push(
          this.portalIdentityConfigurationForm
            .get(controlName)
            ?.valueChanges.subscribe((value) => {
              this.formSections.forEach((section) => {
                if (section.context?.controls?.includes(controlName)) {
                  section.context.actionsSection.isSaveEnable = true;
                }
              });
              //
            })
        );
      }
    );
  }
}
